import React, { useEffect, useRef } from "react";
import styles from "./FilterLayout.module.css";
import { Button, Input } from "antd";
import Filter from "../../assets/svg/filter-icon.svg";
import Search from "../../assets/svg/search-icon.svg";
const FilterLayout = (props) => {
  const {
    children,
    className,
    onSearch,
    search,
    setSearch,
    placeHolder,
    isVisible,
    setIsVisible,
    reportFilter,
    disabledFilter,
  } = props;
  const filterRef = useRef();

  const handleEnter = (e) => {
    if (e.key === "Enter") {
      onSearch();
    }
  };

  useEffect(() => {
    if (isVisible) {
      const handleClick = (e) => {
        if (!filterRef.current.contains(e.target)) {
          setIsVisible(false);
        }
      };
      window.addEventListener("click", handleClick);

      return () => {
        window.removeEventListener("click", handleClick);
      };
    }
    // eslint-disable-next-line
  }, [isVisible]);

  return (
    <div className={`${styles.FilterLayout} ${className || ""}`}>
      {reportFilter && (
        <Button className="button-primary color-white-1" onClick={reportFilter}>
          <span>Report</span>
        </Button>
      )}
      <Button
        className={`button-outline-gray ${
          reportFilter ? "w-100px" : "w-200px"
        } ${styles.FilterLayoutButton} `}
        onClick={() => setIsVisible(!isVisible)}
        disabled={disabledFilter}
      >
        <img src={Filter} alt="" width="15px" className="mr-5 pb-5" />
        <span>Filter</span>
      </Button>
      <div
        className={`${styles.SearchBox} ${
          reportFilter ? styles.SearchBoxWithReportBtn : ""
        }`}
      >
        <Input
          className="input-black border-black-8 mb-10"
          placeholder={
            placeHolder
              ? placeHolder
              : "Search by first name, last name, mobile number"
          }
          onKeyDown={handleEnter}
          onChange={(e) => setSearch(e.target.value)}
          value={search}
        />
        <img src={Search} alt="" width="25px" onClick={() => onSearch()} />
      </div>
      <div
        ref={filterRef}
        className={`${styles.FilterFormContainer} ${
          isVisible ? styles.Show : ""
        }`}
      >
        <div onClick={(e) => e.stopPropagation()}>{children}</div>
      </div>
    </div>
  );
};

export default FilterLayout;
